export default __webpack_public_path__ + "static/subset-SuisseIntl-Medium-1f5facd868c748c8c43a2f42d4d65454.woff";